import { render, staticRenderFns } from "./LangSwitcher.vue?vue&type=template&id=6982a061&scoped=true&"
import script from "./LangSwitcher.vue?vue&type=script&lang=js&"
export * from "./LangSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./LangSwitcher.vue?vue&type=style&index=0&id=6982a061&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6982a061",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VFadeTransition,VSelect})
